import { render } from "./Tooltip.vue?vue&type=template&id=023003d2&scoped=true&ts=true"
import script from "./Tooltip.vue?vue&type=script&lang=ts"
export * from "./Tooltip.vue?vue&type=script&lang=ts"

import "./Tooltip.vue?vue&type=style&index=0&id=023003d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023003d2"]])

export default __exports__